import React, { CSSProperties, FC, ReactElement } from 'react'
import { Spinner, SpinnerProps } from 'react-bootstrap'

import './LoadingWrapper.scss'

interface ILoadingWrapperProps extends CSSProperties {
  loading: boolean
  children: ReactElement
  style?: CSSProperties
  className?: string
  size?: SpinnerProps['size']
}

const LoadingWrapper: FC<ILoadingWrapperProps> = ({
  loading,
  children,
  className,
  style,
  size,
  ...overrideStyles
}) => {
  return loading ? (
    <div
      className={`loading-wrapper--layout ${className ? className : ''}`}
      style={{
        ...overrideStyles,
        ...style
      }}
    >
      <Spinner size={size} animation="border" />
    </div>
  ) : children
}

export default LoadingWrapper
